const getters = {
  auth: state => state.auth,
  socket: state => state.socket,
};

export default getters;
